import MockAdapter from 'axios-mock-adapter/types'

export function mockAccountBalances(mocker: MockAdapter) {
  mocker.onGet('/trading/0/balances').reply(() => {
    return [
      200,
      {
        code: 200,
        msg: 'success',
        data: {
          BTC: ['10', '0'],
          USDT: ['10001110', '0'],
        },
      },
    ]
  })
}
